import { render, staticRenderFns } from "./personDriver.vue?vue&type=template&id=26312502&scoped=true&"
import script from "./personDriver.vue?vue&type=script&lang=js&"
export * from "./personDriver.vue?vue&type=script&lang=js&"
import style0 from "./personDriver.vue?vue&type=style&index=0&id=26312502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26312502",
  null
  
)

export default component.exports